import { redirect } from "@tanstack/react-router";

import type { FeatureAccessMap, FeatureFlagKey } from "@/lib/feature-flags";

/**
 * Route guard for flagged pages. A user without the flag is sent home as if the
 * page did not exist; the API answers 404 for the same reason.
 */
export function requireFeature(features: FeatureAccessMap | null | undefined, key: FeatureFlagKey) {
  if (!features?.[key]?.visible) throw redirect({ to: "/" });
}
